import { connect, FormikContextType } from 'formik'
import React, { ReactNode, useState } from 'react'
import { InputCep } from '@components/form'
import { LocationsApi } from '@services/api/locations'
import { useToasts } from 'react-toast-notifications'

interface PropsAddres {
  state: string
  city: string
  neighborhood?: string
  street?: string
}
interface Props<T> {
  name: string
  label?: ReactNode
  disabled?: boolean
  formik?: FormikContextType<T>
  propertyAddress: PropsAddres
  className?: string
  tabIndex?: number
}

function LoadAddressByCep<T>({
  name,
  label,
  formik,
  propertyAddress,
  disabled,
  ...props
}: Props<T>) {
  const { addToast } = useToasts()
  const [cepOld, setCepOld] = useState('')

  const findInfoByCep = async cepWithMask => {
    const cep = cepWithMask.replace(/_|\./g, '')
    if (!cep || cep.length < 9 || cepOld === cep) {
      setCepOld(cep)
      return
    }

    setCepOld(cep)

    try {
      const {
        data: { address }
      } = await LocationsApi.address({ cep })
      address.stateId &&
        formik.setFieldValue(propertyAddress.state, address.stateId)
      address.cityId &&
        formik.setFieldValue(propertyAddress.city, address.cityId)

      propertyAddress.neighborhood &&
        address.neighborhood &&
        formik.setFieldValue(propertyAddress.neighborhood, address.neighborhood)

      propertyAddress.street &&
        address.street &&
        formik.setFieldValue(propertyAddress.street, address.street)
    } catch (error) {
      console.error(error)
      addToast('Nenhum endereço encontrado com este CEP', {
        autoDismiss: true,
        appearance: 'warning'
      })
    }
  }

  return (
    <InputCep
      name={name}
      placeholder=""
      label={label}
      onChange={value => {
        findInfoByCep(value)
      }}
      disabled={disabled}
      {...props}
    />
  )
}

export const LoadAddressByCepComponent = connect(LoadAddressByCep)
